import { SERVICE_METHOD } from "constants/order";

export default function isDelivery(serviceMethod = "") {
  return serviceMethod === SERVICE_METHOD.DELIVERY;
}
